import React, { Component } from 'react';
import axios from 'axios';
import '../assets/css/login.css';
import BootstrapModal from '../components/modals/bootstrap-modal';
import NavButton from '../components/nav-button';
import SpinnerModal from '../components/modals/spinner-modal';

class ResetPassword extends Component {
    constructor(props) {
        super(props);
        this.state = {
            spinnerOn: false,
            password: '',
            passwordConfirmation: '',
        };
        this.submit = this.submit.bind(this);
        this.onClose = this.onClose.bind(this);
    }

    async componentDidMount() {
        const { reset_token } = this.props.match.params;
        this.setState({ spinnerOn: true, reset_token }); // this is required
    }

    onClose() {
        console.log('modal closed...');
    }

    change(e) {
        this.setState({
            [e.target.name]: e.target.value
        });
    }

    async submit(e) {
        e.preventDefault();
        document.getElementById("trigger-spinner-modal").click(); // open spinner

        const reset_password = {
            code: this.state.reset_token,
            password: this.state.password,
            passwordConfirmation: this.state.passwordConfirmation,
        };

        try {
            // https://strapi.io/documentation/developer-docs/latest/development/plugins/users-permissions.html#reset-password-send-the-new-password

            // get token from backend
            let result = await axios.post(`${process.env.REACT_APP_API_ENDPOINT}/auth/reset-password`, reset_password);

            if (result.status === 200) {
                this.setState({modalHeader: `Success`,
                    modalBody: `
                    Your password has be changed successfully. You will be redirected to log in momentarily.
                    `,
                    classNameValue: 'success'
                });
                document.getElementById("trigger-status-modal").click();
                document.getElementById("mySpinnerModal").click(); // close spinner

                // redirect to login
                setTimeout(function () {
                        window.location.replace(`/login`);
                }, 10000);
            } else {
                this.setState({modalHeader: `Failure`,
                    modalBody: `
                    Something failed. Please contact your administrator.
                    `,
                    classNameValue: 'danger'
                });
                document.getElementById("trigger-status-modal").click();
                console.log('result failure', result);
            }
        } catch (error) {
            localStorage.removeItem('hoaoa-jwt');
            localStorage.removeItem('hoaoa-user');
            document.getElementById("mySpinnerModal").click(); // close spinner

            console.log('An error occurred:', error);
            console.log('error.response', error.response);
            // console.log('error messages', error.response.data['message'][0]['messages']);
            let modalBody = '';
            for (let message of error.response.data['message'][0]['messages']) {
                console.log('message', message);
                modalBody += `${message.message}. `
            }
            this.setState({modalHeader: `Error ${error.response.status}`,
                modalBody,
                classNameValue: 'danger'
            });
            document.getElementById("trigger-status-modal").click();
        }

        // axios
        // .post(`${process.env.REACT_APP_API_ENDPOINT}/auth/local`, {
        //     // identifier: 'test@test.com',
        //     // password: '1',
        //     identifier: this.state.email,
        //     password: this.state.password
        // })
        // .then(response => {
        //     // Handle success.
        //     localStorage.setItem('hoaoa-jwt', response.data.jwt);
        //     window.location.replace(`/secure/association/${response.data.user.association_id.token}`);
        //     // this.props.history.push('/association/'); // forward the user to his assigned association
        // })
        // .catch(error => {
        //     // Handle error.
        //     console.log('An error occurred:', error);
        //     localStorage.removeItem('hoaoa-jwt');
        //     localStorage.removeItem('hoaoa-user');
        //     document.getElementById("mySpinnerModal").click(); // close spinner
        //     this.setState({modalHeader: `Sorry`,
        //         modalBody: `
        //         Invalid credentials. Please try again or contact your administrator.
        //         `,
        //         classNameValue: 'danger'
        //     });
        //     document.getElementById("trigger-status-modal").click();
        // });

    }

    render() {
        if (this.state.loading) {
            return (
            <div className="App">
              <h1>Loading...</h1>
            </div>
          )
        }
        const { spinnerOn, reset_token } = this.state;

        return (
            <div className="FormCenter App">
                {spinnerOn ? <SpinnerModal /> : null}
                <br />
                <form onSubmit={e => this.submit(e)} className="FormFields" >
                <div className="FormField">
                        <label className="FormField__Label" htmlFor="reset_token">Reset Token</label>
                        <input type="hidden" id="reset_token" className="FormField__Input" name="reset_token" value={reset_token} />
                    </div>
                    <div className="FormField">
                        <label className="FormField__Label" htmlFor="password">Password</label>
                        <input autoFocus type="password" id="password" className="FormField__Input" required placeholder="Enter your password" name="password" onChange={e => this.change(e)} />
                    </div>
                    <div className="FormField">
                        <label className="FormField__Label" htmlFor="passwordConfirmation">Confirm Password</label>
                        <input type="password" id="passwordConfirmation" className="FormField__Input" required placeholder="Confirm your password" name="passwordConfirmation" onChange={e => this.change(e)} />
                    </div>
                    <div className="FormField">
                        <button type="submit" className="FormField__Button">Submit</button>
                    </div>
                    <input type="hidden" id="trigger-status-modal" data-toggle="modal" data-target="#status-modal" />
                    <input type="hidden" id="trigger-spinner-modal" data-toggle="modal" data-target="#mySpinnerModal" />
                </form>
                <br />
                <NavButton toPage={`/login`} access="p" type={`go`} text={`Return To Login`} />
                <BootstrapModal onClose={this.onClose} cbForBootstrapModal={{header: this.state.modalHeader, body: this.state.modalBody, customID: "status-modal", classNameValue: this.state.classNameValue}}/>
            </div>
        );
    }

}

export default ResetPassword;
